import * as React from "react";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  TextField,
  Button,
  CardMedia,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import finger from "../../images/svg/finger.svg";
import LoginIcon from "@mui/icons-material/Login";
import { rsToken, rsProgress, rsAddress } from "../../RecoilStates";
import { UseLogin } from "./UseLogin";
import { useRecoilState } from "recoil";

export default function Login() {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const { doLogin } = UseLogin();
  const [msToken, setMsToken] = useRecoilState(rsToken);
  const [openD, setOpenD] = useState(false);
  const [msAddress, setMsAddress] = useRecoilState(rsAddress);

  useEffect(() => {
    if (msToken) {
      setMsAddress(false);
      navigate("/");
    }
  }, [msToken]);

  const [loginCommand, setLoginCommand] = useState({
    cell: "",
    pass: "",
  });

  return (
    <Box
      sx={{
        backgroundImage: `url(${window.ENV.loginBack})`,
        // backgroundColor: "primary.main",
        backgroundSize: "cover",
        width: "100%",
        height: "100%",
        backgroundPosition: "center",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          background: "#011b33",
          p: 5,
          top: { md: "50%" },
          backgroundImage: `linear-gradient(to left, #011b33 , #213d54)`,
          left: { md: "20%" },
          transform: { md: `translate(-50%, -50%)` },
          borderRadius: 10,
          boxShadow: 5,
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenD(true);
            doLogin(loginCommand, (callback) => {
              setOpenD(false);
            });
          }
        }}
        className="login"
      >
        <CardMedia
          sx={{ width: "70px", mx: "auto", my: 1 }}
          component="img"
          alt="green iguana"
          image={finger}
        />
        <CardMedia
          sx={{ mx: "auto", my: 4, width: "150px" }}
          component="img"
          alt="green iguana"
          image={window.ENV.logo2}
        />

        <TextField
          className="login"
          sx={{
            mb: 3,
            width: "90%",
            color: "white",
            "& .MuiOutlinedInput-notchedOutline": {},
            "& .MuiFormLabel-root": {
              color: "white",
            },
            "& .MuiInputBase-input": {
              color: "white",
            },
            "& .MuiInputBase-input-MuiInput-input": {
              color: "white",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "white !important",
            },

            "& .Mui-focused": {
              color: "white !important",
            },
          }}
          id="outlined-basic"
          label="شماره موبایل"
          size="small"
          variant="outlined"
          value={loginCommand.cell}
          onChange={(evt) => {
            setLoginCommand({
              ...loginCommand,
              cell: evt.target.value,
            });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          className="login"
          sx={{
            width: "90%",
            mb: 3,
            color: "white",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "white",
            },
            "& .MuiFormLabel-root": {
              color: "white",
            },
            "& .MuiInputBase-input": {
              color: "white",
            },
            "& .MuiInputBase-input-MuiInput-input": {
              color: "white",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "white !important",
            },
            "& .Mui-focused": {
              color: "white !important",
            },
          }}
          type="password"
          size="small"
          id="outlined-basic"
          label="رمز عبور"
          variant="outlined"
          value={loginCommand.pass}
          onChange={(evt) => {
            setLoginCommand({
              ...loginCommand,
              pass: evt.target.value,
            });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <Button
          sx={{ px: 5, my: 2 }}
          variant="contained"
          onClick={() => {
            setOpenD(true);
            doLogin(loginCommand, (callback) => {
              setOpenD(false);
            });
          }}
        >
          <LoginIcon sx={{ mr: 0.5 }}></LoginIcon>
          ورود
        </Button>
      </Box>
      <Backdrop open={openD} sx={{ zIndex: 10000 }}>
        <CircularProgress color="secondary" />
      </Backdrop>
    </Box>
  );
}
